module.exports = __webpack_public_path__ + "img/ag-pro-logo.a97e7bd6.jpg";